import React from "react";
import AutomatedMessageText from "../../AutomatedMessageText";

const AutomatedMessageMarkedBookedEnquiry = ({ children }) => {
  return (
    <AutomatedMessageText tagTitle="Booked?">{children}</AutomatedMessageText>
  );
};

export default AutomatedMessageMarkedBookedEnquiry;
